import type { InspectionRecord, TenantDatabase } from '@/shared/offline';

/**
 * Een ingediende opname is bevroren: de API weigert elke wijziging
 * (`acceptsAnswers()` is dan `false`) en een correctie loopt via het rapport.
 * De app laat het daar niet op aankomen en weigert zelf al.
 */
export class InspectionLockedError extends Error {
    constructor(readonly inspectionUuid: string) {
        super('Deze opname is ingediend en niet meer te wijzigen.');
        this.name = 'InspectionLockedError';
    }
}

export function isSubmitted(inspection: Pick<InspectionRecord, 'status'> | undefined): boolean {
    return inspection?.status === 'submitted';
}

/** Binnen een `applyMutation`: gooit als de opname ingediend is. */
export async function assertEditable(db: TenantDatabase, inspectionUuid: string): Promise<void> {
    if (isSubmitted(await db.inspections.get(inspectionUuid))) {
        throw new InspectionLockedError(inspectionUuid);
    }
}
